export const is = {
    LEFT: 'Vinstri: Fært til fyrri daginn.',
    RIGHT: 'Hægri: að Fara á næsta dag.',
    DOWN: 'Niður: að Fara í næstu línu.',
    UP: 'Upp: Fært til fyrri röðinni.',
    PGUP: 'PgUp: Fara í fyrra mánuði.',
    PGDOWN: 'PgDown: að Fara á næsta mánuði.',
    HOME: 'Heim: Fært til fyrri ári.',
    END: 'Enda: að Fara á næsta ári.',
    ESC: 'Kofum/í Dag/Loka: loka dagbók.',
    TITLE: 'Lyklaborð Leiðbeiningar'
};
